export enum BackgroundTaskCustomReportTypes {
  DETAILSED = 'detailed',
  SUMMARY = 'summary',
  SUMMARY_BY_WO = 'summary_by_wo'
}
